export default __webpack_public_path__ + "static/media/TLINR_Splash.df4eb27f.jpg";